/**
 * Module
 */
require('./app/app.module.js');

/**
 * Constants
 */
require('./app/app.constants.js');

/**
 * Directives
 */
require('./app/widgets/tlpsNumeric/tlpsNumericDrct.js');
require('./app/widgets/tlps.directives.js');
require('./app/widgets/tlpsSpinner/tlpsSpinnerDrct.js');

/**
 * Components
 */
require('./app/components/tlpsProposta/tlpsProposta.cmpt.js');
require('./app/components/tlpsProposta/tlpsPropostaSrvc.js');
require('./app/components/tlpsProposta/tlpsDefinizione/tlpsDefinizione.cmpt.js');
require('./app/components/tlpsProposta/tlpsDefinizione/tlpsDefinizioneSrvc.js');
require('./app/components/tlpsProposta/tlpsDefinizione/tlpsDettaglioProdotto/tlpsDettaglioProdotto.cmpt.js');
require('./app/components/tlpsProposta/tlpsDefinizione/tlpsDatiAggiuntivi/tlpsDatiAggiuntivi.cmpt.js');
require('./app/components/tlpsProposta/tlpsQuestionari/tlpsQuestionari.cmpt.js');
require('./app/components/tlpsProposta/tlpsQuestionari/tlpsQuestionariSrvc.js');
require('./app/components/tlpsProposta/tlpsDocumenti/tlpsDocumenti.cmpt.js');
require('./app/components/tlpsProposta/tlpsModale/tlpsModale.cmpt.js');

require('./app/components/tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglie.cmpt.js');
require('./app/components/tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglieSrvc.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCarico.cmpt.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoSrvc.js');
require('./app/components/tlpsApprovvigionamento/visualizzazioneApparati/visualizzazioneApparati.cmpt.js');
require('./app/components/tlpsApprovvigionamento/visualizzazioneApparati/visualizzazioneApparatiSrvc.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBanca.cmpt.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBancaSrvc.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoFiliale/presaInCaricoFiliale.cmpt.js');
require('./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoFiliale/presaInCaricoFilialeSrvc.js');

require('./app/components/tlpsPostVendita/tlpsPostVenditaTelepass/tlpsPostVenditaTelepass.cmpt.js');
require('./app/components/tlpsPostVendita/tlpsPostVendita.cmpt.js');
require('./app/components/tlpsPostVendita/tlpsPostVenditaSrvc.js');
require('./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoTelepass.cmpt.js');
require('./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoTelepassSrvc.js');
require('./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDefinizione.cmpt.js');
require('./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDettaglioProdotto/tlpsTraslocoDettaglioProdotto.cmpt.js');
require('./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDatiAggiuntivi/tlpsTraslocoDatiAggiuntivi.cmpt.js');

/**
 * Services
 */
require('./app/components/servicesUtilities/labelSrvc.js');
require('./app/components/servicesUtilities/messaggiFctr.js');
require('./app/components/servicesUtilities/domainSrvc.js');
require('./app/components/servicesUtilities/userSrvc.js');
require('./app/components/servicesUtilities/loggerSrvc.js');

/**
 * Run
 */
require('./app/app.run.js');

/**
 * Config
 */
require('./app/app.route.js');



//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 40
// module chunks = 0